import { Modal, Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { serverApi } from "../../../api";
import { SelectElement } from "../../../components/selectElement2";

export const CrearModuloModal = ({ show, onClose, onSave, ubicaciones }) => {

    const [errors, setErrors] = useState({});

     const validateForm = () => {
        const newErrors = {};

        if (!form.ideUbicacion) {
            newErrors.ideUbicacion = 'Debe seleccionar una ubicación';
        }

        if (!form.uidModuloClase.trim()) {
            newErrors.uidModuloClase = 'Debe seleccionar una clase';
        }

        if (!form.modulo.trim()) {
            newErrors.modulo = 'Debe ingresar el nombre del modulo';
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };


    // const [ ubicaciones, setUbicaciones ] = useState([]); 
    const [ moduloClases, setModuloClases ] = useState([]); 
    
    const [form, setForm] = useState({
        ideUbicacion: '',
        codigoUbicacion: '',
        uidModuloClase: '',
        recibeTraslados: false,
        modulo: '' 
    });

    const resetForm = () => {
        setForm({
            ideUbicacion: '',
            codigoUbicacion: '',
            uidModuloClase: '',
            recibeTraslados: false,
            modulo: ''
        });
    };


    useEffect(() => {
        if (!show) {
            resetForm();
        }
    }, [show]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));

        setErrors(prev => ({
            ...prev,
            [name]: ''
        }));
    };

    useEffect(() => {
        if (!show) return;

        const codigoEntidad = localStorage.getItem("codigoEntidad");
        if (!codigoEntidad) return;

        const loadModulo = async () => {
            try {
                const resp = await serverApi.post(`/modulos/select-moduloClases`, { codigoEntidad });
                const opciones = resp.data.clases.map((item) => ({ value: item.uidModuloClase, label: item.moduloClase.toUpperCase() }));
                setModuloClases(opciones);
            } catch (error) {
                console.error("Error al obtener clases Modulos", error);
            }
        };

        loadModulo();
    }, [show]);

    const handleSelectUbicacion = (selected) => {
        setForm(prev => ({
            ...prev,
            ideUbicacion: selected.value,
            codigoUbicacion: selected.data
        }));

        setErrors(prev => ({
            ...prev,
            ideUbicacion: ''
        }));
    };

    const handleSelectModuloClases = (selected) => {
        setForm(prev => ({
            ...prev,
            uidModuloClase: selected.value,
        }));

        setErrors(prev => ({
            ...prev,
            uidModuloClase: ''
        }));
    };
    
    // const handleUbicacionRegistro = (selected) =>{
    //     console.log(selected);
    //     setUbicacionRegistro( selected );
    // }

    // const handleModuloClasesRegistro = (selected) =>{
    //     console.log(selected);
    //     setModuloClaseRegistro( selected );
    // }

    const handleSubmit = () => {

        if (!validateForm()) return;

        console.log( form );
        
        onSave({ ...form });
        // setModulo("");
    };

    return (
        <Modal show={show} onHide={onClose} centered size="lg">
        
        <Modal.Header closeButton className="border-0 pb-0">
            <Modal.Title className="fw-bold fs-4">Crear módulo</Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <Form>
                <Form.Group>
                    <Form.Label>Sede/ubicación</Form.Label>
                    <SelectElement
                        options= { ubicaciones }
                        name={ `idUbicacion`}
                        isMulti= {false}
                        closeOnMenuSelect= {true}
                        value={ubicaciones.find(u => u.value === form.ideUbicacion)}
                        onChange= {(selected) => handleSelectUbicacion(selected)}
                        classname= "form-control form-control-lg" 
                        isClearable = {false}
                    />
                    {errors.ideUbicacion && (
                        <div className="invalid-feedback d-block">
                            {errors.ideUbicacion}
                        </div>
                    )}

                </Form.Group>
                <Form.Group>
                    <Form.Label>Clase</Form.Label>
                    <SelectElement
                        options= { moduloClases }
                        name={ `uidModuloClase`}
                        isMulti= {false}
                        closeOnMenuSelect= {true}
                        value={moduloClases.find(u => u.value === form.uidModuloClase)}
                        onChange= {(selected) => handleSelectModuloClases(selected)}
                        classname= "form-control form-control-lg" 
                        isClearable = {false}
                    />

                    {errors.uidModuloClase && (
                        <div className="invalid-feedback d-block">
                            {errors.uidModuloClase}
                        </div>
                    )}

                </Form.Group>

                <Form.Group>
                    <Form.Label>Módulo</Form.Label>
                    <Form.Control
                        name="modulo"
                        value={form.modulo}
                        onChange={handleChange}
                        placeholder="Ej: Caja 1"
                        isInvalid={!!errors.modulo}

                    />
                </Form.Group>
                <Form.Control.Feedback type="invalid">
                    {errors.modulo}
                </Form.Control.Feedback>

                <div className="form-check form-switch ">
                {/* { console.log(typeof(item.uidModulo), typeof(moduloSeleccionado) ) } */}
                    <label className="form-check-label" htmlFor="chkAsignado_">Recibe Traslados</label>
                    
                    <input 
                        className="form-check-input" 
                        checked= {form.recibeTraslados } 
                        type="checkbox" 
                        id={`recibeTraslados`} 
                        name={`recibeTraslados`} 
                        onChange={handleChange}

                     
                    />

                </div>    


            </Form>
        </Modal.Body>

        <Modal.Footer  className="border-0 pt-0">
            <Button variant="light" onClick={onClose}>
            Cancelar
            </Button>

            <Button variant="primary" onClick={handleSubmit}>
            Guardar
            </Button>
        </Modal.Footer>

        </Modal>
    );
};